import axios from '../../axios'

/*
 * 用户管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/banner/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/banner/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/banner/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/banner/detail',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/banner/banner.js